/**
 * prefix a string with zero
 * @param {String} str string which need zero prefix
 *
 * @returns {String}
 */
function prefix0 (str, length) {
  return (str + '').padStart(2, '0')
}

/**
 * @param {Date} date a date object
 * @param {"date" | "time" | "datetime"} type result type, 'date', 'time' or 'datetime', default value is 'date'
 *
 * @returns {String}
 */

export default function format (date, type = 'date', seperator = '-', seconds = false) {
  const y = date.getFullYear()
  const M = prefix0(date.getMonth() + 1)
  const d = prefix0(date.getDate())
  const h = prefix0(date.getHours())
  const m = prefix0(date.getMinutes())
  const s = prefix0(date.getSeconds())

  const dateStr = `${y}${seperator}${M}${seperator}${d}`
  const timeStr = `${h}:${m}`

  switch (type) {
    case 'time':
      return timeStr
    case 'datetime':
      return dateStr + ' ' + timeStr + (seconds ? ':' + s : '')
    default:
      return dateStr
  }
}
